export const INITIAL_STATE = {
    name: '',
    minPoints: '',
    redemptionRatio: '',
    description: '',
    loading: false,
    error: '',
    fieldErrors: {},
};

export const SUCCESS_MESSAGE = 'Tier created successfully!';

export const TOAST_MESSAGES = {
    success: 'Tier Added Successfully!',
    error: 'Failed to add tier. Please try again.',
};

export const VALIDATION_ERROR_MESSAGES = {
    name: 'Tier name is required.',
    minPoints: 'Minimum redemption points is required and must be greater than or equal to 1.',
    redemptionRatio: 'Redemption ratio is required and must be greater than 0.',
};

export const TIER_STATUSES = [
    { id: 'ACTIVE', name: 'Active' },
    { id: 'INACTIVE', name: 'Inactive' },
];

export const ADD_TIER_FORM_FIELDS = [
    {
        name: 'name',
        label: 'Tier Name',
        type: 'text',
        placeholder: 'e.g. Bronze, Silver, Gold',
        required: true,
    },
    {
        name: 'minPoints',
        label: 'Minimum Redemption Points',
        type: 'number',
        placeholder: 'e.g. 1',
        required: true,
    },
    {
        name: 'description',
        label: 'Description',
        type: 'text',
        placeholder: 'Brief description of this tier',
        required: false,
    },
];

export const DUMMY_TIERS = [
    {
        id: 1,
        name: 'Bronze',
        minPoints: 0,
        maxPoints: 999,
        multiplier: 1.0,
        description: 'Entry level tier for new members',
        status: 'ACTIVE',
    },
    {
        id: 2,
        name: 'Silver',
        minPoints: 1000,
        maxPoints: 4999,
        multiplier: 1.5,
        description: 'Mid-level tier with enhanced rewards',
        status: 'ACTIVE',
    },
    {
        id: 3,
        name: 'Gold',
        minPoints: 5000,
        maxPoints: 14999,
        multiplier: 2.0,
        description: 'Premium tier with double points',
        status: 'ACTIVE',
    },
    {
        id: 4,
        name: 'Platinum',
        minPoints: 15000,
        maxPoints: 99999,
        multiplier: 3.0,
        description: 'Elite tier with exclusive benefits',
        status: 'ACTIVE',
    },
    {
        id: 5,
        name: 'Diamond',
        minPoints: 100000,
        maxPoints: 999999,
        multiplier: 4.0,
        description: 'Top-tier for our most loyal members',
        status: 'INACTIVE',
    },
];
